export default {
  // PWA
  'app.pwa.offline': '当前为离线状态',
  'app.pwa.serviceworker.updated': '有新内容',
  'app.pwa.serviceworker.updated.hint': '请点击"刷新"按钮或者手动刷新页面',
  'app.pwa.serviceworker.updated.ok': '刷新',

  // 全局头部
  'component.globalHeader.search': '站内搜索',
  'component.globalHeader.search.example1': '搜索提示一',
  'component.globalHeader.search.example2': '搜索提示二',
  'component.globalHeader.search.example3': '搜索提示三',
  'component.globalHeader.help': '使用文档',
  'component.globalHeader.notification': '通知',
  'component.globalHeader.notification.empty': '暂无通知',
  'component.globalHeader.message': '消息',
  'component.globalHeader.message.empty': '暂无消息',
  'component.globalHeader.event': '待办',
  'component.globalHeader.event.empty': '暂无待办',

  // 设置
  'app.settings.menuMap.basic': '基本设置',
  'app.settings.menuMap.security': '安全设置',
  'app.settings.menuMap.binding': '账号绑定',
  'app.settings.menuMap.notification': '新消息通知',

  // 通用操作
  'app.common.operate': '操作',
  'app.common.more-operate': '更多操作',
  'app.common.add': '新增',
  'app.common.edit': '编辑',
  'app.common.delete': '删除',
  'app.common.view': '查看',
  'app.common.save': '保存',
  'app.common.cancel': '取消',
  'app.common.confirm': '确认',
  'app.common.reset': '重置',
  'app.common.search': '搜索',
  'app.common.submit': '提交',
  'app.common.back': '返回',
  'app.common.next': '下一步',
  'app.common.previous': '上一步',
  'app.common.loading': '加载中...',
  'app.common.no-data': '暂无数据',
  'app.common.refresh': '刷新',
};
